import {connect} from 'react-redux';
import SupporterCommentsBlock from '../../../components/blocks/supporter/SupporterCommentsBlock';
import {
    getComments,
    addComment,
    changeAddEditText,
    saveAddEditComment,
    undoAddEditComment,
    deleteComment,
    bookmarkComment
} from '../../../actions/supporterCommentsAction';

const mapStateToProps = (state, ownProps) => {
    return {
        supporterId: ownProps.supporterId,
        supporterComments: state.supporterComments
    }
};

const mapDispatchToProps = dispatch => {
    return {
        getComments(id) {
            dispatch(getComments(id))
        },
        addComment() {
            dispatch(addComment())
        },
        changeAddEditText(message) {
            dispatch(changeAddEditText(message))
        },
        saveAddEditComment(data) {
            dispatch(saveAddEditComment(data))
        },
        undoAddEditComment() {
            dispatch(undoAddEditComment())
        },
        deleteComment(data) {
            dispatch(deleteComment(data))
        },
        bookmarkComment(data) {
            dispatch(bookmarkComment(data))
        }
    }
};

const SupporterCommentsBlockContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(SupporterCommentsBlock);

export default SupporterCommentsBlockContainer;